// extracted by mini-css-extract-plugin
export default {"wrap":"BunchModalContent_wrap__xOCu2","wrap_label":"BunchModalContent_wrap_label__gYI6E","field_NameKkm":"BunchModalContent_field_NameKkm__OaUKD"};